import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import configData from './config.js'
import axios from './axios-auth'
import 'highlight.js'
import './assets/style.scss'
import VueCodeHighlight from 'vue-code-highlight';

import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
import {Quill} from 'vue-quill-editor'
import VueQuillEditor from 'vue-quill-editor'
import {VueMathjax} from 'vue-mathjax'
// import Jupyter from '@jupyterlab/services'
import {InlineSvgPlugin} from 'vue-inline-svg';


Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

Vue.config.productionTip = false
axios.defaults.baseURL = configData.baseURL

Vue.use(InlineSvgPlugin);
Vue.use(VueCodeHighlight)

/*
window.MathJax.Hub.Config({
  // jax: ['input/TeX'],
  // extensions: ['tex2jax.js'],
  //tex2jax: {inlineMath: [['$', '$'], ['\\(', '\\)']]},
  asciimath2jax: {
    delimiters: [['x','x']]
   },
  asciimath: {
    delimiters: [['x','x']]
  },
  MathML: {
    useMathMLspacing: true
  },
  AsciiMath: {
    fixphi: true,
    useMathMLspacing: true,
    displaystyle: false,
    decimalsign: "."
  }
  /*
  jax: ['input/AsciiMath'],
  extensions: ['asciimath2jax.js'],
  tex2jax: {
   inlineMath: [["$","$"],["\\(","\\)"]],
   displayMath: [['$$','$$'], ["\\[","\\]"]]
  },
  asciimath2jax: {
   delimiters: [['\\$','\\$'], ['`','`']]
  }
 });
*/
new Vue({  
  router,
  store,
  vuetify,
  VueQuillEditor,
  VueMathjax,
//  Jupyter,
  render: h => h(App)
}).$mount('#app')

/*
this.$vuetify.theme.themes.dark.primary = 'green'
this.$vuetify.theme.themes.light.primary = 'green'
this.$vuetify.theme.dark.primary = 'green'
this.$vuetify.theme.light.primary = 'green'
*/

